module.exports = __webpack_public_path__ + "static/media/USD.936feee6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/currencies/USD.svg
// module id = 2370
// module chunks = 7